import React from 'react';
import PhoneInput from "react-phone-input-2";

interface PhoneNumberDisplayProps {
  phone: string | null | undefined;
  textColor?: string;
  country?: string; // Allows the user to specify the default country code
  disableDropdown?: boolean; // Allow showing the country dropdown
  disableCountryCode?: boolean; // Option to disable country code prefix
  enableAreaCodes?: boolean; // Option to enable area codes
  className?: string;
}

const PhoneNumberDisplay: React.FC<PhoneNumberDisplayProps> = ({
  phone,
  textColor = "",
  country = "US", // Default country set to 'US'
  disableDropdown = true,
  disableCountryCode = false,
  enableAreaCodes = false,
}) => {
  if (!phone) return <p style={{ color: textColor }}>N/A</p>; // Handle missing phone number

  return (
    <PhoneInput
      value={phone}
      country={country} // Dynamically set the default country
      disableDropdown={disableDropdown} // Allow disabling country dropdown
      enableAreaCodes={enableAreaCodes} // Option to allow extra area codes
      disableCountryCode={disableCountryCode} // Option to disable country code display
      inputStyle={{
        padding: "0",
        border: "none", // Remove border from input
        boxShadow: "none", // Remove shadow
        color: textColor, // Use dynamic text color
      }}
      containerStyle={{
        display: "flex",
      }}
      buttonStyle={{
        display: "none", // Hide the flag button
      }}
      disabled={true}
      inputClass='text-gray-800 dark:text-white'
    />
  );
};

export default PhoneNumberDisplay;

export const normalizeDigits = (raw?: string | null) =>
  String(raw ?? "").replace(/\D/g, "");

export const formatPhoneLabel = (raw?: string | null) => {
  const digits = normalizeDigits(raw);
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits.startsWith("1")) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return raw || "";
};

export const formatTelHref = (raw?: string | null) => {
  const digits = normalizeDigits(raw);
  if (!digits) return "";
  if (digits.length === 10) return `+1${digits}`;
  return `+${digits}`;
};
